
export function getAssetPath(path) {
  const prefix = import.meta.env.VITE_APP_ASSETS_HOST || '';
  
  if (!prefix) return path;
  
  // Clean up slashes
  const cleanPrefix = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${cleanPrefix}${cleanPath}`;
}
